import { CookieStorage } from 'cookie-storage';

export const cookieStorage = new CookieStorage({ path: '/' });
